<template>
    <common-page flex-column>
        <h4 class="text-secondary">Settings:</h4>
        <div class="flex-row">
            <template v-for="item of typeInfo">
                <b-button :key="item.key" @click="openLocationFilter(item.key)" variant="primary" class="h-60px ml-2">
                    {{ item.label }}
                </b-button>
            </template>
            <b-button @click="otdSwitchShow" variant="primary" class="h-60px ml-2">OTD计算规则设置</b-button>
        </div>

        <h4 class="text-secondary">Export:</h4>
        <div class="flex-row">
            <b-button @click="openExport('hour')"
                      variant="warning"
                      class="h-60px ml-2">
                导出计划标准工时报表
            </b-button>
            <b-button @click="openExport('finish')" variant="warning" class="h-60px ml-2">
                导出完成计划工时报表
            </b-button>
            <b-button @click="openExportOTD" variant="warning" class="h-60px ml-2">导出工序OTD报表</b-button>
        </div>

        <template #outer>
            <FilterTreeModal ref="locationFilter"
                             :header="theTypeInfo.label" :entity="theTypeInfo.entity"
                             :checked-ids="locationFilters"
                             @checkFinish="saveResult($event, locationFilterType)"></FilterTreeModal>
        </template>

        <el-dialog title="OTD计算规则设置" width="40%" :visible.sync="otdSwitchVisible"
                   :close-on-click-modal='false' append-to-body>
            <el-form :model="otdSwitchForm" ref="otdSwitchForm" label-width="auto">
                <el-card>
                    <el-form-item label="">
                        <el-radio-group v-model="otdSwitchForm.otdOpenRules"> <!--  @change="showRadio3Options" -->
                            <!--<el-radio :label="0">人工统计KPI</el-radio>--> <!-- 隐藏选项，仅系统参数可调 -->
                            <el-radio :label="1">规则一(新版)</el-radio>
                            <el-radio :label="2">规则二(原版)</el-radio>
                            <el-radio :label="3">显示全部</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="">
                        (规则一)人工统计KPI参数：
                        <el-switch
                            v-model="otdSwitchForm.otdCustomKpiEnable"
                            active-text="开启"
                            inactive-text="关闭">
                        </el-switch>
                        <br>
                        (规则一)最大延迟天数：
                        <el-input-number v-model="otdSwitchForm.otdRule1LateDays" :min="0" :max="365"
                                         label="请输入天数" style="margin-top: 20px"></el-input-number>
                        <div style="margin-top: 20px" v-show="radio3Show">
                            <span>(显示全部-至少1条)OTD曲线组合开关：</span>
                            <el-checkbox-group v-model="checkedLine" :min="1" :max="4">
                                <el-checkbox v-for="line in otdLineGroup" :label="line" :key="line">{{ line }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div style="margin-top: 20px">
                            <span>OTD人工报表数据（请按json格式谨慎调整，不要回车换行，如果json格式存在错误，数据将不会被替换到看板）：</span>
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 6}"
                                placeholder="请正确编辑json格式的人工报表数据内容。如果配置数据内容为空，请刷新看板，看板实时计算结果将按json格式填入当前配置编辑框内。"
                                v-model="otdSwitchForm.otdManualData">
                            </el-input>
                        </div>
                    </el-form-item>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="otdSwitchVisible = false">关 闭</el-button>
                <el-button type="primary" @click="updateOtdSwitchStatus()">修 改</el-button>
            </div>
        </el-dialog>

        <el-dialog title="OTD报表导出" width="40%" :visible.sync="otdReportVisible" :close-on-click-modal='false'>
            <el-form :model="otdSwitchForm" ref="otdSwitchForm" label-width="auto">
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>导出OTD报表按设定计算规则一/二导出，请注意启用的计算规则</span>
                    </div>
                    <span class="demonstration">请选择导出月份：</span>
                    <el-date-picker
                        v-model="otdSwitchForm.exportMonth"
                        type="month"
                        placeholder="选择导出月份">
                    </el-date-picker>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="otdReportVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOTD()">导 出</el-button>
            </div>
        </el-dialog>

        <el-dialog title="报表导出" width="40%" :visible.sync="exportHourVisible"
                   :close-on-click-modal='false'>
            <el-card>
                <span class="demonstration">请选择导出月份：</span>
                <el-date-picker
                    v-model="exportHourTargetMonth"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="month"
                    placeholder="选择导出月份">
                </el-date-picker>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportHourVisible = false">取 消</el-button>
                <el-button type="primary" @click="doExport()">导 出</el-button>
            </div>
        </el-dialog>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import FilterTreeModal from "@/components/echarts-part/kpi/stuff/FilterTreeModal";
import EmCommonApi from "@/mixin/em/common/api";

export default {
    name: "KpiSettings",
    components: {FilterTreeModal, CommonPage},
    mixins: [emLevelTreeListMixin, emCommonUtilMixin, EmCommonApi],
    data() {
        return {
            locationFilterType: '',
            typeInfo: [
                {
                    key: 'StandardHour',
                    label: '设置计划标准工时包含的工位',
                    entity: 'sithMesMstLocation'
                },
                {
                    key: 'ServiceHour',
                    label: '设置服务工时包含的工位',
                    entity: 'sithMesMstLocation'
                },
                {
                    key: 'APT',
                    label: '设置APT包含的工位',
                    entity: 'sithMesMstLocation'
                },
                {
                    key: 'PARTS',
                    label: '设置PARTS包含的工位',
                    entity: 'sithMesMstLocation'
                },
                {
                    key: 'AP',
                    label: '设置AP包含的工位',
                    entity: 'sithMesMstLocation'
                },
                {
                    key: 'T',
                    label: '设置T包含的工位',
                    entity: 'sithMesMstLocation'
                },
            ],
            locationFilters: "",
            otdSwitchVisible: false,
            otdReportVisible: false,
            otdSwitchForm: {
                otdOpenRules: 1,
                otdCustomKpiEnable: 0,
                otdRule1LateDays: 0,
                allOtdLineGroup: '',
                exportMonth: null,
                otdManualData: '',
            },
            selectedDate: null, // 存储日期选择器的值
            radio3Show: false,
            checkedLine: [],
            otdLineGroup: ['AP_OTD', 'T_OTD', 'PARTS_OTD', 'AP_OTD_R2', 'T_OTD_R2', 'PARTS_OTD_R2'],

            exportHourVisible: false,
            exportHourTargetMonth: null,
            exportType: ''
        }
    },
    mounted() {

    },
    computed: {
        theTypeInfo() {
            for (let item of this.typeInfo) {
                if (item.key === this.locationFilterType) {
                    return item;
                }
            }
            return {entity: ''};
        },
    },
    watch: {
        locationFilterType() {
            if (this.locationFilterType) {
                this.getLocationFilter();
            }
        }
    },
    methods: {
        otdSwitchShow() {
            this.getSysParamOTDSwitchRules()
            this.otdSwitchVisible = true;
        },
        getSysParamOTDSwitchRules() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesMstLocation/kpi/getSysParamOTDSwitchRules`
            this.$_emApiMixin_get(_api, false).then(value => {
                //console.log("------------ OTD Open rules --------->>>")
                //console.log(value)
                _this.otdSwitchForm.otdOpenRules = parseInt(value.otdOpenRules);
                _this.otdSwitchForm.otdCustomKpiEnable = value.otdCustomKpiEnable === '1' ? true : false;
                _this.otdSwitchForm.otdRule1LateDays = parseInt(value.otdRule1LateDays);
                _this.otdSwitchForm.exportMonth = new Date();
                _this.otdSwitchForm.allOtdLineGroup = value.allOtdLineGroup;
                _this.otdSwitchForm.otdManualData = value.otdManualData;
                this.checkedLine = _this.otdSwitchForm.allOtdLineGroup.split(",")
                //console.log(this.checkedLine)
                //this.showRadio3Options(); //2024.3.6 按默认全部显示，这个开关暂时屏蔽，待后期做“自由组合”再修改利用
                console.log(_this.otdSwitchForm)
            })
        },
        updateOtdSwitchStatus() {
            let _url = process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesMstLocation/setOtdSwitchRules"
            this.otdSwitchForm.allOtdLineGroup = this.checkedLine.join(",")
            console.log(_url)
            this.$store.dispatch('api/post', {
                url: _url,
                data: this.otdSwitchForm
            }).then(() => {
                this.$message.success("规则变更成功");
                //this.locationFilterType = '';
                this.otdSwitchVisible = false;
            });
        },
        openLocationFilter(type) {
            this.locationFilterType = type;
            this.$refs.locationFilter.showModal();
        },
        saveResult(checkedNodes, type) {
            let tempList = []
            for (let item of checkedNodes) {
                tempList.push(item.id);
            }
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/set" + type + "LocationFilter?value=" + tempList.join(","),
                data: {}
            }).then(() => {
                this.$message.success("操作成功");
                this.locationFilterType = '';
            });
        },
        getLocationFilter() {
            this.$refs.locationFilter.changeLoading(true);
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/get" + this.locationFilterType + "LocationFilter"
            }).then(response => {
                this.locationFilters = response;
            }).finally(() => this.$refs.locationFilter.changeLoading(false));
        },
        openExport(type) {
            this.exportHourVisible = true;
            this.exportType = type;
        },
        doExport() {
            switch (this.exportType) {
                case "hour":
                    this.exportHour();
                    break;
                case "finish":
                    this.exportFinishPlanHour();
                    break;
            }
            this.exportHourVisible = false;
        },
        exportHour() {
            this.postExport({
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/standardHour/export",
                data: {
                    from: this.exportHourTargetMonth
                },
                name: "计划标准工时详情"
            });
        },
        exportFinishPlanHour() {
            this.postExport({
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/finishPlanHour/export",
                data: {
                    from: this.exportHourTargetMonth
                },
                name: "完成计划工时详情"
            });
        },
        openExportOTD() {
            this.getSysParamOTDSwitchRules();
            this.otdReportVisible = true;
        },
        exportOTD() {
            this.postExport({
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstLocation/export/otd",
                data: this.otdSwitchForm,
                name: "工序OTD"
            });

            this.otdReportVisible = false;
        },
        showRadio3Options() {
            if (this.otdSwitchForm.otdOpenRules == 3) {
                this.radio3Show = true;
            } else {
                this.radio3Show = false;
            }
        }
    }
}
</script>

<style scoped>
.h-60px {
    height: 60px;
    margin-bottom: .25rem;
}
</style>
